import Immutable, { Record } from 'immutable';

const AbilityRecord = Record({
  abilityId: undefined,
  name: undefined,
  point: undefined,
});

class Ability extends AbilityRecord { }

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'abilityId':
      return [key, `${val}`];
    default:
      return [key, Immutable.fromJS(val)];
  }
};

Ability.create = (data) =>
  new Ability(data).mapEntries(reviver);

export default Ability;



// WEBPACK FOOTER //
// ./data/ProgressTests/Skills/Abilities/model.js